import { useCallback } from 'react';

import { useRouter, useSearchParams } from 'hooks/navigation';

/**
 * Navigates while carrying the current query string over to the new route.
 *
 * Replaces useRedirectWithAnimation, which routed through the custom page
 * transition wrapper. That wrapper unmounted the whole page for the length of
 * the exit animation on every navigation, which took the route-based settings
 * down with it and restarted the 3D scene's animations.
 */
export const useRedirectPreservingParams = () => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const push = useCallback(
    (url: string) => {
      const existingParams = new URLSearchParams(searchParams.toString());
      const baseUrl = url.split('?')[0];
      const newUrl = `${baseUrl}?${existingParams.toString()}`;

      router.push(newUrl);
    },
    [router, searchParams]
  );

  return { push };
};
